import React from 'react';
import "./header.scss";
import { Link, useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();

  const goToLanding = ()=>{
    navigate('/')
  }
  return (
    <div className="header-wrapper">
      <div>
        <img onClick={goToLanding} className='logo' src='/assets/images/logo.png' />
      </div>
      <div className='social-media'>
        <div className='facebook'>
          <Link to={'https://www.facebook.com/mosipremiumlager'} target='blank'><img src='/assets/images/fb.png' /></Link>
        </div>
        <div className='instagram'>
          <Link to={'http://instagram.com/mosi_premium_lager'} target='blank'><img src='/assets/images/insta.png' /></Link>
        </div>
      </div>
    </div>
  );
}

export default Header;
